import React, { useEffect } from "react";
import "./home.css";
import HomeImage from "../../assets/homePage.png";
import { useNavigate } from "react-router-dom";
import { getContent } from "../../api/adminApi/content";

const Top = () => {
  const navigate = useNavigate();
  const [content, setContent] = React.useState({
    "title1": "",
    "title2": "",
    "title3": "",
    "title4": "",
    "title5": "",
    "title6": "",
    "content1": "",
    "content2": "",
    "content3": "",
    "content4": "",
    "content5": "",
    "content6": ""
  });

  useEffect(() => {
    getContent().then((res) => {
      // console.log(res.data.title2);
      setContent(res.data);
    });
  }, []);

  const handleRegisterClick = () => {
    navigate("/register");
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="home-top-full-wrapper">
      <div className="home-top-conainer">
        <div className="homeTop-small-image">
          <img className="home-small-image" src={HomeImage} alt="" />
        </div>
        <div className="homeTop-left">
          <span className="sub-title">
          {/* {content.title1} */} Find your talent with us!
          </span>
          <span className="main-title">
            {/* {content.title2}  */} Welcome to 
          </span>
          <span className="main-title">
            {/* {content.title2}  */} Open Curtains Casting
          </span>
          <span className="subColor-title">
            {content.content1}
          </span>
          <div className="homeTop-buttons">
            <button className="homeTop-join" onClick={handleRegisterClick}>
              Join Now
            </button>
            <button className="homeMiddle2" onClick={handleRegisterClick}>
              Post Your Casting Call
            </button>
          </div>
        </div>
        <div className="homeTop-right">
          <img className="home-image" src={HomeImage} alt="" />
        </div>
      </div>
    </div>
  );
};

export default Top;

// Title 1 Unleash the Magic of Youth – Find Your Star with Us!
// Title 2 Start your journey to stardom today with Open Curtains Casting!
// Title 3 Explore thousands of updated casting calls, from commercials to feature films
